import React from 'react'

function Icon({active = '#202020'}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill={active}
        fillOpacity="0.5"
        d="M8 14.667A6.667 6.667 0 118 1.334a6.667 6.667 0 010 13.333zM4.675 12.17A5.31 5.31 0 008 13.333a5.313 5.313 0 003.445-1.261 4.653 4.653 0 00-3.338-1.405 4.652 4.652 0 00-3.432 1.504zm-.931-.958a5.984 5.984 0 014.363-1.88 5.982 5.982 0 014.241 1.756 5.333 5.333 0 10-8.604.125zM8 8.667a2.667 2.667 0 110-5.334 2.667 2.667 0 010 5.334zm0-1.334a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z"
      ></path>
    </svg>
  )
}

export default Icon
